import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { anonymousLogin } from '../api/user';
import { setAuthorizationData } from 'src/utils/localStorage';

// 匿名登录
export const getAnonymousTokenRequest: any = createAsyncThunk('energyOverview/getEnergyOverview',
  async () => {
    try {
      const res = await anonymousLogin();
      return res;
    } catch (error: any) {}
  }
);

const getAnonymousTokenSlice = createSlice({
  name: 'getAnonymousToken',
  initialState: {
  },
  reducers: {},
  extraReducers (builder) {
    builder.addCase(getAnonymousTokenRequest.fulfilled, (state, { payload }) => {
      const searchParams = new URLSearchParams(window.location.search);
      const accessMode = searchParams.get('access_mode') ? searchParams.get('access_mode') : 'normal';
      if (accessMode === 'preview') {
        setAuthorizationData({ previewToken: payload?.object?.token || '' });
      } else {
        setAuthorizationData({ anonymousToken: payload?.object?.token || '' });
      }
    }).addCase(getAnonymousTokenRequest.rejected, (state, err) => {
    });
  }
});
export default getAnonymousTokenSlice.reducer;
